export { HSpaced as default, HSpacedProps } from './HSpaced'
